/**
 * @file checkboxでの項目表示／非表示
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ToggleCheckbox
 * @classdesc checkboxでの項目表示／非表示
 */
export default class ToggleCheckbox {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-checkbox-toggle=true]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor/ ${$e.attr('name')}`);
		this._$e = $e;
		this._name = $e.attr('name');
		this._$target = $($e.attr('data-target'));
		this._$e.on('click', () => this.onClick());
		this.onClick();
	};


	/**
	 * Clickのコールバック
	 *
	 * @memberof ToggleCheckbox
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		if (this._$e.prop('checked')) {
			this._$target.show().find('.validate').removeClass('ignore-validate');
			if (this._name === 'discontinuous_enabled') {
				if ($('#ob_og_y').prop('checked')) {
					$('#ob-og-mail-wrap').show();
					$('[name=old_member_email]').removeClass('ignore-validate');
				} else {
					$('[name=old_member_email]').addClass('ignore-validate');
				}
			}
		} else {
			Common.addIgnoreValidate(this._$target);
			this._$target.hide().find('.validate').removeClass('is-invalid').addClass('ignore-validate').val('');
			this._$target.find('.error-tip').removeClass('show').find('error-tip-inner').text('');
			if (this._name === 'fee-exemption') {
				Common.addIgnoreValidate($('#fee-exemption-reason-other'));
			}
			setTimeout(() => {
				if (this._name === 'discontinuous_enabled') {
					Common.addIgnoreValidate($('#ob-og-mail-wrap'));
				}
			}, 500);
		}
	}
}
